import {
    IRecordTypeFeatureInfoClick,
    MapListRecordItem
} from "esdm-map";


export class LhlpMapListRecordItem extends MapListRecordItem {
    protected recordLinkHtml(feature: IRecordTypeFeatureInfoClick): string {
        return `
            <a href="/${this.controller(feature)}/${feature.uid}" title="Go to record details" itemprop="url">
                <span>
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
${feature.name}
                </span>
            </a>&nbsp;
        `;
    }

    public controller = (feature: IRecordTypeFeatureInfoClick): string => {
        let val: string = "";

        switch (feature.recordType.toLowerCase()) {
            case "nhle":
                val = "NHLE";
                break;            
        }

        return val;
    }

}